import { render, staticRenderFns } from "./ForumNotifications.vue?vue&type=template&id=13f247f3&"
import script from "./ForumNotifications.vue?vue&type=script&lang=js&"
export * from "./ForumNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports